import React from 'react'
import { Paper, Typography, Button, IconButton } from '@material-ui/core'
import { Close, Edit } from '@material-ui/icons'
import { withStyles } from '@material-ui/core/styles'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

const styles = theme => ({
  card: {
    width: 200,
    margin: theme.spacing.unit,
    padding: theme.spacing.unit,
    display: 'flex',
    justifyContent: 'space-between'
  },
  banner: {
    height: 100,
    width: 200,
    maxWidth: 200
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  },
  cardContent: {
    height: '100%',
    padding: theme.spacing.unit,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'stretch'
  },
  streamTitle: {
    lineHeight: '150%',
    alignSelf: 'stretch'
  },
  deleteButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: 'white',
    width: 30,
    height: 30,
    padding: 0,
    opacity: 0.5
  },
  editButton: {
    position: 'absolute',
    top: 0,
    right: 32,
    backgroundColor: 'white',
    width: 30,
    height: 30,
    padding: 0,
    opacity: 0.5
  },
  deleteIcon: {
    color: '#000000'
  }
})

const StreamCard = ({
  classes,
  image,
  title,
  descr,
  price,
  startDate,
  actionLabel,
  onStartStream,
  removeStream,
  removeConfirmText,
  id,
  editStream }) => {
  const { t } = useTranslation()

  const renderCloseIcon = () => {
    if (removeStream) {
      return (
        <IconButton
          className={classes.deleteButton}
          aria-label='delete'
          size='small'
          onClick={() => {
            const isRemove = window.confirm((removeConfirmText || t('Cabinet:delete subscribe confirm')))
            if (isRemove) removeStream(id)
          }}>
          <Close fontSize='inherit' className={classes.deleteIcon}/>
        </IconButton>
      )
    }
  }

  const renderEditIcon = () => {
    if (editStream) {
      return (
        <IconButton
          className={classes.editButton}
          aria-label='delete'
          size='small'
          onClick={editStream}>
          <Edit fontSize='inherit' className={classes.deleteIcon}/>
        </IconButton>
      )
    }
  }

  return (
    <Paper className={classes.card}>
      <div className={classes.cardContainer}>
        {renderCloseIcon()}
        {renderEditIcon()}
        <img src={image} className={classes.banner} alt='' />
        <div className={classes.cardContent}>
          <Typography gutterBottom variant='subtitle1' className={classes.streamTitle}>
            { title }
          </Typography>
          {
            (descr) ? (
              <Typography variant='body2' color='textSecondary' component='p' >
                {descr}
              </Typography>
            ) : null
          }
          <div className={classes.streamDate}>
            <Typography variant='body2' component='p'>
              { price }
            </Typography>
            <Typography variant='body2' color='textSecondary' component='p'>
              { dayjs(startDate).format('lll') }
            </Typography>
            <Button variant='contained' onClick={onStartStream}>
              { actionLabel }
            </Button>
          </div>
        </div>
      </div>
    </Paper>
  )
}

export default withStyles(styles)(StreamCard)
